import { useInView } from "react-intersection-observer";
import styled from "styled-components";
import Image from "../../../assets/images/image/handwoven-img.jpeg";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { appear } from "../../animations/Appear";

const Wrapper = styled.div`
  height: fit-content;
  width: 100%;
  animation: ${({ inView }) => (inView ? appear : "none")} 2s forwards;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 40px 0px;

  @media (max-width: 950px) {
    flex-direction: column;
  }
`;

const Left = styled.div`
  flex: 1;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 20px;

  span {
    display: flex;
    align-items: center;
    gap: 8px;
    letter-spacing: 0.14rem;
    color: ${colors.maroon};
    font-size: ${fontSize.m};
  }

  p {
    letter-spacing: 0.09rem;
    word-spacing: 0.1rem;
    line-height: 1.6;
    color: ${colors.primaryGray};
    font-size: ${fontSize.xxs};
  }
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding : 40px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 950px) {
    box-sizing : border-box;
  }
`;

const Space = styled.div`
  height: 20px;
`;

function BrowseCollectionTopSection() {
  const { ref, inView } = useInView({
    triggerOnce: false,
  });
  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <Left>
          <span>Handwoven In The Himalayas</span>
          <Space />
          <p>
            All of Peak Pashmina’s apparel is handwoven in the Himalayas from ethically sourced wool and cashmere, never from factories. Local communities care for the animals that roam freely, ensuring sustainable grazing. This centuries-old heritage combines traditional craftsmanship with ethical farming, creating luxurious garments that honor both nature and culture, preserving Himalayan weaving traditions for generations.
            <br />
          </p>
        </Left>
        <Right ref={ref} inView={inView}>
          <img src={Image} alt="2025 Collection" />
        </Right>
      </Container>
    </Wrapper>
  );
}

export default BrowseCollectionTopSection;
